import { Route, Routes } from 'react-router';

import PrivateRoute from 'app/components/Util/PrivateRoute';
import RolesEnum from 'utils/enums/Roles';

import { AccessPermissions } from './AccessPermissions';
import { AccessSettingsOverview } from './AccessSettingsOverview';
import { EntitlementGroups } from './EntitlementGroups';
import { Entitlements } from './Entitlements';
import { RoleSettings } from './Roles/RoleSettings';

export const AccessSettingsRoutes = ({ currentUser }) => {
  return (
    <Routes>
      <Route
        index
        element={
          <PrivateRoute requires={{ entitlements: [RolesEnum.SUPER_USER] }} user={currentUser}>
            <AccessSettingsOverview />
          </PrivateRoute>
        }
      />
      <Route
        path="entitlements"
        element={
          <PrivateRoute
            requires={{
              entitlements: [RolesEnum.SUPER_USER]
            }}
            user={currentUser}
          >
            <Entitlements />
          </PrivateRoute>
        }
      />
      <Route
        path="entitlement-groups"
        element={
          <PrivateRoute
            requires={{
              entitlements: [RolesEnum.SUPER_USER]
            }}
            user={currentUser}
          >
            <EntitlementGroups />
          </PrivateRoute>
        }
      />
      <Route
        path="roles"
        element={
          <PrivateRoute
            requires={{
              entitlements: [RolesEnum.SUPER_USER]
            }}
            user={currentUser}
          >
            <RoleSettings />
          </PrivateRoute>
        }
      />
      <Route
        path="access-permissions"
        element={
          <PrivateRoute
            requires={{
              entitlements: [RolesEnum.SUPER_USER]
            }}
            user={currentUser}
          >
            <AccessPermissions />
          </PrivateRoute>
        }
      />
      {/* <Route
        path="publication-permissions"
        element={
          <PrivateRoute
            requires={{
              entitlements: [RolesEnum.SUPER_USER]
            }}
            user={currentUser}
          >
            <PublicationPermissions />
          </PrivateRoute>
        }
      /> */}
    </Routes>
  );
};
